"use client";

import { useTranslations } from "next-intl";
import { Stack, Text } from "@leabankab/component-library";
import { StepHeader } from "@/components/layout/step-header";
import { BenefitList } from "@/components/ui";

interface VoluntaryUpsellHeaderProps {
	hasSuggestions: boolean;
	hasManualDebts: boolean;
}

const BENEFIT_KEYS = ["onePayment", "oneRate", "betterOverview"] as const;

export const VoluntaryUpsellHeader = ({
	hasSuggestions,
	hasManualDebts,
}: VoluntaryUpsellHeaderProps) => {
	const t = useTranslations("pages.RefinancePage");

	if (hasManualDebts && !hasSuggestions) {
		return (
			<StepHeader align="left" title={t("voluntary.activeHeading")}>
				<Text color="text.subtle">{t("voluntary.activeSubtitle")}</Text>
			</StepHeader>
		);
	}

	return (
		<Stack gap={2.5}>
			<Text>
				{hasSuggestions
					? t("voluntary.suggestedDescription")
					: t("voluntary.description")}
			</Text>
			<BenefitList
				items={BENEFIT_KEYS.map((key) => t(`voluntary.benefits.${key}.title`))}
			/>
		</Stack>
	);
};
